import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { InspectionConfigurationSearchCriteria } from '../models/searchCriteria/InspectionConfigurationSearchCriteria';
import { InspectionConfiguration, InspectionConfigurationDetail } from '../models/InspectionConfiguration';

@Injectable({
  providedIn: 'root'
})
export class InspectionConfigurationService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: InspectionConfigurationSearchCriteria): Observable<PagedData<InspectionConfiguration>> {
    return this.httpClient.post<PagedData<InspectionConfiguration>>(environment.apiUrl + "inspection-configurations/filtered",searchCriteria);
  }

  get(id: number): Observable<InspectionConfigurationDetail<any>> {
    return this.httpClient.get<InspectionConfigurationDetail<any>>(environment.apiUrl + "inspection-configurations/" + id);
  }

  save(inspectionConfiguration: InspectionConfiguration): Observable<void> {
    if (inspectionConfiguration.id == 0 || inspectionConfiguration.id === undefined) {
      return this.httpClient.post<void>(environment.apiUrl + "inspection-configurations", inspectionConfiguration);
    }
    else {
      return this.httpClient.put<void>(environment.apiUrl + "inspection-configurations/" + inspectionConfiguration.id, inspectionConfiguration);
    }
  }
 
  delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "inspection-configurations/" + id);
  }
 
 
}  